import React from "react";

const DesktopIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4069_16623)">
      <path
        d="M13.6003 3.75806H2.93359C1.82902 3.75806 0.933594 4.65349 0.933594 5.75806V11.7581C0.933594 12.8626 1.82902 13.7581 2.93359 13.7581H13.6003C14.7048 13.7581 15.6003 12.8626 15.6003 11.7581V5.75806C15.6003 4.65349 14.7048 3.75806 13.6003 3.75806Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.93359 15.7581H11.6003"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4069_16623">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.265625 0.380615)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DesktopIcon;
